// import { MotionPathPlugin } from "gsap/MotionPathPlugin";
// import { TextPlugin } from "gsap/TextPlugin";
//import { ScrollSmoother } from "gsap/ScrollSmoother";

if (process.client) {
  // gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, TextPlugin, ScrollSmoother);
}

// let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

// fadeInUpEl.forEach((container) => {
//     let tl = gsap.timeline({
//         scrollTrigger: {
//             trigger: container,
//             start: "center bottom",
//             stagger: 0.2
//             // toggleActions: "restart none none reset",
//         }
//     });

//     tl.set(container, { autoAlpha: 1 });
//     tl.from(container, 1, {
//         opacity: 0,
//         y: 100,
//         ease: "power2.out"
//     });
// });

// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
// ScrollTrigger.refresh();
// const scrollSmoother_home = ScrollSmoother.create({
//     wrapper: '#home_wrapper',
//     content: "#home",
//     smooth: 3,
//     effects: true
// });

// console.log(scrollSmoother_home)
